module.exports = __webpack_public_path__ + "static/media/emily-willis-icon.a2381a0c.jpg";